module.exports = __webpack_public_path__ + "570fa0d6.png";